import { TextField } from '@cimpress/react-components';
import React, { useState } from 'react';
import { useDebounce } from 'react-use';

// tslint:disable-next-line:import-name
import style from '../index.module.css';

export interface ReferencesFilterProps {
  onChange: (references: string[]) => void;
  className?: string;
}

// tslint:disable-next-line:function-name
export default function ReferencesFilter(
  {
    className,
    onChange,
  }: ReferencesFilterProps,
) {
  const [val, setVal] = useState('');

  useDebounce(
    () => {
      const references = val.split(',').map(v => v.trim()).filter(v => v.length);
      setVal(references.join(', '));
      onChange(references);
    },
    500,
    [val],
  );

  return <div className={`${className ?? ''} ${style.References}`}>
    <h6>References (<i>Comma separated list</i>)</h6>
    <TextField
      onChange={({ currentTarget }) => setVal(currentTarget.value)}
      value={val}
    />
  </div>;
}
